import React from "react";
import PropTypes from "prop-types";
import NarrativeTokenField from "../NarrativeTokenField";

/**
 * TextField - a labeled prose editor for a free-text narrative field that may carry @figure
 * tokens: what_changed / why / what_to_do / decision_required (see NarrativeRail.jsx /
 * DecisionBlock.jsx for where each is consumed). Same shape as SummaryField - kept as a
 * separate component (rather than one component under two names) because the two represent
 * distinct narrative concepts (a page summary vs. a narrative-body paragraph) even though
 * today's implementation is identical; a future divergence (e.g. per-field max length, distinct
 * placeholder copy) has an obvious home. Extracted from NarrativeRail (SP6 Task 5).
 */
const TextField = ({ label, value, onChange, disabled, metrics, catalog, onFocus }) => (
  <div className="block">
    <span className="block text-xs font-medium text-text-2 mb-1">{label}</span>
    <NarrativeTokenField
      value={value || ""}
      onChange={onChange}
      metrics={metrics}
      catalog={catalog}
      disabled={disabled}
      ariaLabel={label}
      onFocus={onFocus}
    />
  </div>
);

TextField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  metrics: PropTypes.object,
  catalog: PropTypes.array,
  onFocus: PropTypes.func,
};

export default TextField;
